<div>
    <dropzone (addedFile)="onSelect($event)"
              [config]="config"
              [message]="'Click or drag file here to upload'"
              class="dropzone-container">
    </dropzone>
</div>